(() => {
  'use strict';
  const teardown = new WeakMap();
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const controller = new AbortController();
    const cleanups = [];
    const on = (target, type, listener, options = {}) => target?.addEventListener(type, listener, { ...options, signal: controller.signal });
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    teardown.set(root, () => { controller.abort(); cleanups.forEach(cleanup => cleanup()); delete root.dataset.initialized; });
    const stage = $('.dgap-main-image');
    const originalImage = stage?.src;
    const originalAlt = stage?.alt;
    const videoWrapper = $('[data-video]');
    const videoButton = $('[data-video-button]');
    const stageWrapper = $('.dgap-stage');
    const thumbs = $$('[data-gallery-src]');
    const mediaButtons = $$('[data-gallery-src], [data-video-button]');
    const thumbnailTrack = $('.dgap-thumbs');
    let mediaIndex = 0;
    const updateMediaState = (index) => {
      mediaIndex = index;
      mediaButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      $('[data-gallery-count]').textContent = `${index + 1} / ${mediaButtons.length}`;
      const thumb = mediaButtons[index];
      if (thumb && thumbnailTrack) {
        const box = thumbnailTrack.getBoundingClientRect();
        const item = thumb.getBoundingClientRect();
        if (thumbnailTrack.scrollHeight > thumbnailTrack.clientHeight + 2) thumbnailTrack.scrollTop += item.top - box.top - (box.height - item.height) / 2;
        else thumbnailTrack.scrollLeft += item.left - box.left - (box.width - item.width) / 2;
      }
    };
    const showImage = (src, alt) => {
      if (videoWrapper) { videoWrapper.hidden = true; videoWrapper.querySelector('video')?.pause(); }
      stageWrapper?.classList.remove('is-video');
      if (src && stage) { stage.hidden = false; stage.src = src; stage.alt = alt || originalAlt; }
      const index = mediaButtons.findIndex(button => button.dataset.gallerySrc && new URL(button.dataset.gallerySrc, location.href).href === stage.src);
      updateMediaState(Math.max(0, index));
    };
    const selectMedia = (index) => {
      const next = (index + mediaButtons.length) % mediaButtons.length;
      const button = mediaButtons[next];
      if (button.hasAttribute('data-video-button')) {
        stage.hidden = true;
        videoWrapper.hidden = false;
        stageWrapper.classList.add('is-video');
        videoWrapper.querySelector('video')?.play().catch(() => {});
      } else showImage(button.dataset.gallerySrc, button.dataset.galleryAlt);
      updateMediaState(next);
    };
    mediaButtons.forEach((button, index) => on(button, 'click', () => selectMedia(index)));
    on($('[data-gallery-prev]'), 'click', () => selectMedia(mediaIndex - 1));
    on($('[data-gallery-next]'), 'click', () => selectMedia(mediaIndex + 1));
    on($('.dgap-gallery'), 'keydown', (event) => {
      if (event.target.closest('video')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        selectMedia(mediaIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    let touchStart;
    on(stageWrapper, 'pointerdown', (event) => {
      if (event.pointerType !== 'touch' || event.target.closest('button,video')) return;
      touchStart = { x: event.clientX, y: event.clientY };
      stageWrapper.setPointerCapture(event.pointerId);
    });
    on(stageWrapper, 'pointerup', (event) => {
      if (!touchStart) return;
      const dx = event.clientX - touchStart.x;
      const dy = event.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) selectMedia(mediaIndex + (dx < 0 ? 1 : -1));
    });
    on(stageWrapper, 'pointercancel', () => { touchStart = null; });
    updateMediaState(0);
    let variants = [];
    try { variants = JSON.parse($('[data-variants]')?.textContent || '[]'); } catch { /* Native product form remains usable. */ }
    const atc = $('.dgap-atc');
    const status = $('[data-cart-status]');
    const label = $('[data-atc-label]');
    $$('input[name="id"]').forEach((input) => input.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === input.value);
      if (!variant) return;
      $$('[data-price]').forEach((price) => { price.textContent = variant.price; });
      if (atc) atc.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (status) status.hidden = true;
      const isBlack = /black/i.test(variant.title);
      showImage(isBlack ? originalImage : variant.image, isBlack ? originalAlt : `The Asset — ${variant.title}`);
      thumbs.forEach((item,index) => item.setAttribute('aria-pressed',String(isBlack && index === 0)));
    }));
    const restorePurchase = () => {
      $$('input[name="id"]').forEach(input => {
        if (input.dataset.wasDisabled !== undefined) input.disabled = input.dataset.wasDisabled === 'true';
      });
      atc.disabled = false;
      atc.removeAttribute('aria-busy');
      label.textContent = 'Add to cart';
    };
    on(window, 'pageshow', event => { if (event.persisted && atc?.hasAttribute('aria-busy')) restorePurchase(); });
    on($('.dgap-form'), 'submit', async event => {
      if (!window.fetch || !atc || !status) return;
      event.preventDefault();
      if (atc.disabled) return;
      const body = new FormData(event.currentTarget);
      if (!body.get('id')) return;
      atc.disabled = true;
      atc.setAttribute('aria-busy', 'true');
      label.textContent = 'Adding…';
      status.hidden = true;
      status.classList.remove('is-error');
      $$('input[name="id"]').forEach(input => { input.dataset.wasDisabled = String(input.disabled); input.disabled = true; });
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        window.location.assign(root.dataset.checkoutUrl);
      } catch (error) {
        status.classList.add('is-error');
        status.textContent = error.message || 'Unable to add this item. Please try again.';
        status.hidden = false;
        restorePurchase();
      }
    });
    // Keep the buy-box accordions mutually exclusive in browsers without native details grouping.
    const buyDetails = $$('.dgap-buy-accordions details');
    buyDetails.forEach(details => on(details, 'toggle', () => {
      if (details.open) buyDetails.forEach(other => { if (other !== details) other.open = false; });
    }));

    $$('[data-press]').forEach(carousel => {
      const slides = [...carousel.querySelectorAll('[data-press-slide]')];
      let current = 0;
      const measureSlides = () => {
        const area = carousel.querySelector('.dgap-proof-slides');
        area.style.minHeight = '';
        slides.forEach(slide => { slide.hidden = false; });
        const height = Math.max(...slides.map(slide => slide.getBoundingClientRect().height));
        slides.forEach((slide, index) => { slide.hidden = index !== current; });
        if (height) area.style.minHeight = `${Math.ceil(height)}px`;
      };
      measureSlides();
      on(window, 'resize', measureSlides, { passive: true });
      document.fonts?.ready.then(() => { if (root.isConnected) measureSlides(); });
      const interval = setInterval(() => {
        if (reducedMotion.matches || document.hidden || !carousel.offsetWidth) return;
        current = (current + 1) % slides.length;
        slides.forEach((slide, index) => { slide.hidden = index !== current; });
      }, 7000);
      cleanups.push(() => clearInterval(interval));
    });

    const features = $$('[data-feature]');
    const story = $('[data-feature-section]');
    const featureScroll = $('.dgap-feature-scroll');
    const desktop = matchMedia('(min-width: 768px)');
    let activeFeature = -1;
    let scrollStory = false;
    let stepHeight = 120;
    let pinHeight = innerHeight;
    let lastWidth = innerWidth;
    let scrollFrame = 0;
    const showFeature = index => {
      index = Math.max(0, Math.min(features.length - 1, index));
      const changed = activeFeature !== index;
      activeFeature = index;
      features.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        item.querySelector('button').setAttribute('aria-pressed', String(i === index));
        item.inert = scrollStory && !desktop.matches && i !== index;
      });
      if (scrollStory && desktop.matches) featureScroll.style.transform = `translateY(${-features[index].offsetTop}px)`;
      if (changed) {
        const feature = features[index];
        const img = $('.dgap-feature-image');
        img.src = feature.dataset.featureImage;
        img.alt = feature.dataset.featureCaption;
        $('[data-feature-label]').textContent = feature.dataset.featureCaption;
      }
      story.dataset.activeFeature = String(index + 1);
    };
    const syncPageScroll = () => {
      scrollFrame = 0;
      if (!scrollStory || !root.isConnected) return;
      const progress = Math.max(0, -story.getBoundingClientRect().top);
      showFeature(Math.round(progress / stepHeight));
    };
    const selectFeature = index => {
      index = Math.max(0, Math.min(features.length - 1, index));
      if (!scrollStory) return;
      window.scrollTo({ top: story.getBoundingClientRect().top + scrollY + index * stepHeight, behavior: 'instant' });
      showFeature(index);
    };
    const isPinned = () => {
      if (!scrollStory) return false;
      const box = story.getBoundingClientRect();
      return box.top <= 2 && box.top >= -(features.length - 1) * stepHeight - 2;
    };
    const canAdvance = direction => direction > 0 ? activeFeature < features.length - 1 : activeFeature > 0;
    const configureFeatures = () => {
      // Mobile browser chrome changes height while scrolling; keep the story stable until its width changes.
      if (desktop.matches || innerWidth !== lastWidth) pinHeight = innerHeight;
      lastWidth = innerWidth;
      scrollStory = pinHeight >= 600 && !reducedMotion.matches;
      story.style.setProperty('--feature-pin-height', `${pinHeight}px`);
      story.style.setProperty('--feature-run', `${(features.length - 1) * stepHeight}px`);
      story.classList.toggle('is-scroll-story', scrollStory);
      featureScroll.style.transform = '';
      if (scrollStory) syncPageScroll();
      else showFeature(Math.max(0, activeFeature));
    };
    features.forEach((feature, index) => on(feature.querySelector('button'), 'click', () => selectFeature(index)));
    // One wheel/trackpad gesture advances one state, including its momentum tail.
    let wheelTime = 0;
    let wheelDirection = 0;
    let wheelConsumed = false;
    on(window, 'wheel', event => {
      if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.deltaY) return;
      const now = performance.now();
      const direction = Math.sign(event.deltaY);
      if (now - wheelTime > 100 || direction !== wheelDirection) wheelConsumed = false;
      wheelTime = now;
      wheelDirection = direction;
      if (!isPinned()) {
        wheelConsumed = false;
        if (!scrollStory) return;
        const top = story.getBoundingClientRect().top;
        const delta = Math.abs(event.deltaY) * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? pinHeight : 1);
        const run = (features.length - 1) * stepHeight;
        if ((direction > 0 && top > 0 && top <= delta) || (direction < 0 && top < -run && -top - run <= delta)) {
          event.preventDefault();
          wheelConsumed = true;
          selectFeature(direction > 0 ? 0 : features.length - 1);
        }
        return;
      }
      if (wheelConsumed) { event.preventDefault(); return; }
      if (!canAdvance(direction)) return;
      event.preventDefault();
      wheelConsumed = true;
      selectFeature(activeFeature + direction);
    }, { passive: false });
    let featureTouch;
    on(window, 'touchstart', event => {
      if (event.touches.length !== 1) { featureTouch = null; return; }
      featureTouch = { x: event.touches[0].clientX, y: event.touches[0].clientY, consumed: false };
    }, { passive: true });
    on(window, 'touchmove', event => {
      if (!featureTouch || event.touches.length !== 1 || !isPinned()) return;
      const dx = featureTouch.x - event.touches[0].clientX;
      const dy = featureTouch.y - event.touches[0].clientY;
      if (featureTouch.consumed) { event.preventDefault(); return; }
      if (Math.abs(dx) > Math.abs(dy)) return;
      const direction = Math.sign(dy);
      if (!canAdvance(direction)) return;
      event.preventDefault();
      if (Math.abs(dy) < 30) return;
      featureTouch.consumed = true;
      selectFeature(activeFeature + direction);
    }, { passive: false });
    on(window, 'touchend', () => { featureTouch = null; }, { passive: true });
    on(window, 'touchcancel', () => { featureTouch = null; }, { passive: true });
    on(window, 'keydown', event => {
      if (!isPinned() || event.altKey || event.ctrlKey || event.metaKey || event.target.closest('a,button,input,textarea,select,summary,video')) return;
      const direction = ['ArrowDown', 'PageDown', ' '].includes(event.key) ? 1 : ['ArrowUp', 'PageUp'].includes(event.key) ? -1 : 0;
      if (direction && canAdvance(direction)) { event.preventDefault(); selectFeature(activeFeature + direction); }
    });
    on(window, 'scroll', () => { if (scrollStory && !scrollFrame) scrollFrame = requestAnimationFrame(syncPageScroll); }, { passive: true });
    on(window, 'resize', configureFeatures, { passive: true });
    on(reducedMotion, 'change', configureFeatures);
    cleanups.push(() => cancelAnimationFrame(scrollFrame));
    configureFeatures();
    document.fonts?.ready.then(() => { if (root.isConnected) configureFeatures(); });

    const originVideo = $('.dgap-founder-video');
    const originPlay = $('[data-origin-play]');
    on(originPlay, 'click', async () => {
      try { await originVideo.play(); } catch { originVideo.controls = true; }
    });
    on(originVideo, 'play', () => { originPlay.hidden = true; });
    on(originVideo, 'pause', () => { originPlay.hidden = false; });
    on(originVideo, 'ended', () => { originPlay.hidden = false; });
    if (window.IntersectionObserver) {
      const visibility = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-offscreen', !entry.isIntersecting)), { rootMargin: '100px' });
      $$('[data-motion]').forEach(element => visibility.observe(element));
      cleanups.push(() => visibility.disconnect());
      const preload = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        features.forEach(feature => { const image = new Image(); image.src = feature.dataset.featureImage; });
        preload.disconnect();
      }, { rootMargin: '600px' });
      preload.observe(story);
      cleanups.push(() => preload.disconnect());
    }
    const reviews = $('[data-review-track]');
    const prev = $('[data-reviews-prev]');
    const next = $('[data-reviews-next]');
    const updateArrows = () => { if (!reviews) return; prev.disabled = reviews.scrollLeft <= 2; next.disabled = reviews.scrollLeft + reviews.clientWidth >= reviews.scrollWidth - 2; };
    const move = (direction) => reviews?.scrollBy({ left: direction * reviews.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    reviews?.addEventListener('scroll', updateArrows, { passive: true });
    if (window.ResizeObserver && reviews) { const observer = new ResizeObserver(updateArrows); observer.observe(reviews); cleanups.push(() => observer.disconnect()); }
    updateArrows();
  };
  document.querySelectorAll('[data-dgap]').forEach(init);
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-dgap]').forEach(root => teardown.get(root)?.()));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-dgap]').forEach(init));
})();
